import './InputNumber.scss';
import { forwardRef } from "react";
import { InputNumber as PrInputNumber } from 'primereact/inputnumber';
import classNames from "classnames";

const InputNumber = forwardRef(({ className, inputClassName,...props}, ref) => {

  return <PrInputNumber ref={ref} className={classNames('InputNumber', className)} inputClassName={classNames('InputField', inputClassName)}  {...props} />

})

export default InputNumber